<template>
	<div>
		<v-card>
			<v-data-table
				:headers="headers"
				:items="couponCodeData"
				:hide-default-header="$vuetify.breakpoint.xsOnly"
				item-key="id"
				class="elevation-1"
				hide-sort
			/>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'couponCodeTable',
	props: ['couponCodeData'],
	data() {
		return {
			headers: [
				{ text: 'Coupon Code', value: 'coupon_code' },
				{ text: 'Rule Name', value: 'rule_name' },
				{ text: 'Order Status', value: 'order_status' },
				{ text: 'Increment ID', value: 'increment_id' },
				{ text: 'Order Date', value: 'updated_at' },
				{ text: 'Rule Type', value: 'rule_type' },
				{ text: 'Discount Amount', value: 'discount_amount' },
				{ text: 'Item ID', value: 'item_id' },
				{ text: 'Item price (tax. included)', value: 'row_total_incl_tax' },
				{ text: 'Product SKU', value: 'product_sku' },
				{ text: 'Product Name', value: 'product_name' },
				{ text: 'Order ID', value: 'order_id' },
				{ text: 'Store Name', value: 'store_name' },
				{ text: 'Website Name', value: 'website_name' },
				{ text: 'Store Group Name', value: 'store_group_name' },
				{ text: 'Service Provider Name', value: 'serviceprovider_name' },
			],
		}
	},
	computed: {
		
	},
	methods: {
		
	},
};
</script>

<style scoped>

</style>
